export const SET_COUNTERAGENTS = "SET_COUNTERAGENTS";
export const SET_COUNTERAGENT_PAYMENTS = "SET_COUNTERAGENT_PAYMENTS";
export const SET_COUNTERAGENT_ORDERS = "SET_COUNTERAGENT_ORDERS";
export const SET_COUNTERAGENT_RECEIPT_ORDERS =
  "SET_COUNTERAGENT_RECEIPT_ORDERS";
export const SET_COUNTERAGENT_SHIFTS = "SET_COUNTERAGENT_SHIFTS";
export const SET_COUNTERAGENT = "SET_COUNTERAGENT";
